<template>
    <div id="contenedor-listado-mobiles">
        <template v-if="cargando">
            <v-skeleton-loader
                v-for="index in 3"
                :key="`skeleton-${index}`"
                type="card"
                class="mb-2">
            </v-skeleton-loader>
        </template>
        <v-alert
            v-else-if="!listadoLicitaciones.length"
            outlined
            type="info">
            No hay licitaciones para los filtros seleccionados.
        </v-alert>
        <v-card
          v-else
          v-for="(licitacion, index) in listadoLicitaciones"
          :key="`licitacion-${licitacion.id || index}`"
          class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <router-link
                    class="text-truncate text-decoration-none"
                    :to="{ name: 'licitacion', params: { idLicitacion: licitacion.id } }">
                    {{ licitacion.numero }}
                  </router-link>
                  <div
                    class="d-inline-block">
                    <opciones
                      :licitacion="licitacion">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    <div class="caption grey--text text--darken-1 mb-2">
                      {{ formatFechaLocal(licitacion.fechaConvocatoria) }}
                    </div>
                    <div class="mb-2 d-flex flex-wrap align-center">
                      <v-chip
                        small
                        dark
                        class="mr-2 mb-1"
                        :color="getEstadoDerivadoMeta(licitacion.estadoDerivado).color">
                        {{ getEstadoDerivadoMeta(licitacion.estadoDerivado).texto }}
                      </v-chip>
                      <v-chip
                        small
                        outlined
                        color="secondary"
                        class="mr-2 mb-1">
                        Participantes: {{ licitacion.totalParticipantes || 0 }}
                      </v-chip>
                    </div>
                    <div
                      class="caption mb-2"
                      :class="getClaseUrgenciaEvento(licitacion.siguienteEvento)">
                      {{ getTextoSiguienteEvento(licitacion.siguienteEvento) }}
                    </div>
                    {{ licitacion.objeto }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    :to="{ name: 'licitacion', params: { idLicitacion: licitacion.id } }">
                    Ver detalle
                  </v-btn>
                </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
  methods: {
    formatFechaLocal(fecha) {
      if (!fecha) return '';

      // Evita desfases por zona horaria cuando la API envía solo fecha (YYYY-MM-DD).
      if (typeof fecha === 'string') {
        const soloFechaMatch = fecha.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (soloFechaMatch) {
          const [, anio, mes, dia] = soloFechaMatch;
          return new Date(Number(anio), Number(mes) - 1, Number(dia)).toLocaleDateString();
        }
      }

      const parsed = new Date(fecha);
      if (Number.isNaN(parsed.getTime())) return '';
      return parsed.toLocaleDateString();
    },
    getEstadoDerivadoMeta(estadoDerivado) {
      const estados = {
        BORRADOR: { texto: 'Borrador', color: '#9E9E9E' },
        PROGRAMADA: { texto: 'Programada', color: '#5C6BC0' },
        CON_PARTICIPANTES: { texto: 'Con participantes', color: '#00897B' },
        EN_EVALUACION: { texto: 'En evaluacion', color: '#FB8C00' },
        FALLO_CAPTURADO: { texto: 'Fallo capturado', color: '#8E24AA' },
        LISTA_PARA_CONTRATAR: { texto: 'Lista para contratar', color: '#3949AB' },
        CONTRATADA: { texto: 'Contratada', color: '#2E7D32' },
      };

      return estados[estadoDerivado] || { texto: estadoDerivado || 'Sin estado', color: '#607D8B' };
    },
    getTextoSiguienteEvento(siguienteEvento) {
      if (!siguienteEvento || !siguienteEvento.fechaHora) return 'Sin evento proximo';

      const fechaEvento = new Date(siguienteEvento.fechaHora);
      if (Number.isNaN(fechaEvento.getTime())) return 'Sin evento proximo';

      const fechaTexto = fechaEvento.toLocaleDateString();
      const nombreEvento = siguienteEvento.eventoTexto || 'Evento';
      return `${nombreEvento}: ${fechaTexto}`;
    },
    getClaseUrgenciaEvento(siguienteEvento) {
      if (!siguienteEvento || !siguienteEvento.fechaHora) return 'grey--text text--darken-1';

      const fechaEvento = new Date(siguienteEvento.fechaHora);
      if (Number.isNaN(fechaEvento.getTime())) return 'grey--text text--darken-1';

      const ahora = new Date();
      const diffMs = fechaEvento.getTime() - ahora.getTime();
      const horas = diffMs / (1000 * 60 * 60);

      if (horas < 0) return 'red--text text--darken-2';
      if (horas <= 48) return 'orange--text text--darken-2';
      return 'green--text text--darken-2';
    },
  },
};
</script>

<style lang="scss">

</style>
